import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { storage } from '@/configs/storage';
import { COMMENT_SORT_STORE_KEY } from '@/features/posts/constants/store';
import { CommentSortEnum } from '@/features/posts/types/commentSort';

export type CommentSortStore = {
  sort: CommentSortEnum;
  setSort: (sort: CommentSortEnum) => void;
};

export const useCommentSortStore = create<CommentSortStore>()(
  persist(
    (set) => ({
      sort: CommentSortEnum.OLDEST,
      setSort: (newSort: CommentSortEnum) => {
        set({ sort: newSort });
      }
    }),
    { name: COMMENT_SORT_STORE_KEY, storage: createJSONStorage(() => storage) }
  )
);
